module.exports = __webpack_public_path__ + "img/icon3.c5e270c1.png";